import { render, staticRenderFns } from "./LoaderButton.vue?vue&type=template&id=20ff34e4&scoped=true&"
var script = {}
import style0 from "./LoaderButton.vue?vue&type=style&index=0&id=20ff34e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff34e4",
  null
  
)

export default component.exports